export default class ServerTimeProvider {
    static now = () => {
        return new Date(Date.now() + window.SERVER_DATE_OFFSET);
    };
}
